const updates = [
  { title: '《咒术回战》最终卷全集上线', desc: '咒术回战完结篇全部章节已入库，下拉式全集一次看完最终决战！', time: '2小时前', type: '上新' },
  { title: '《鬼灭之刃 无限城篇》全集更新', desc: '鬼灭之刃无限城篇漫画全集补完，经典战斗名场面全收录。', time: '5小时前', type: '更新' },
  { title: '韩漫《再见，我的国王》完结入库', desc: '高分韩漫全集新增，宫斗恋爱剧情跌宕起伏，下拉式阅读超流畅。', time: '8小时前', type: '上新' },
  { title: '夏日漫画专题上线', desc: '暑期漫画全集推荐专题已更新，精选50部适合夏天看的完结漫画。', time: '12小时前', type: '专题' },
  { title: '《暗杀教室》全集高清重制', desc: '经典校园日漫全集高清重制版上线，画质全面提升，体验更佳。', time: '1天前', type: '更新' },
  { title: '下拉式阅读功能优化', desc: '阅读界面优化，加载速度提升40%，下拉式全集浏览更加丝滑流畅。', time: '1天前', type: '系统' },
  { title: '《间谍过家家》全卷整理完成', desc: '间谍过家家漫画全集整理入库，番外篇和特别篇一并收录。', time: '2天前', type: '上新' },
  { title: '韩漫人气榜TOP10更新', desc: '本周韩漫完结作品热度榜刷新，恋爱校园类持续霸榜前三。', time: '2天前', type: '榜单' },
  { title: '免费全集下载服务器扩容', desc: '为了更好的下载体验，全集下载带宽已扩容，离线阅读更快捷。', time: '3天前', type: '系统' },
];

const typeColors: Record<string, string> = {
  '上新': 'bg-primary-100 text-primary-700',
  '更新': 'bg-accent-100 text-accent-700',
  '专题': 'bg-secondary-100 text-secondary-700',
  '系统': 'bg-background-200 text-foreground-500',
  '榜单': 'bg-accent-100 text-accent-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-4">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-xl mx-auto">
          亲亲漫画网最新上架、更新和维护动态，掌握漫画全集一手资讯
        </p>

        <div className="max-w-3xl mx-auto">
          {updates.map((update, i) => (
            <div key={i} className="flex gap-4 pb-6 mb-6 border-b border-background-200 last:border-b-0 last:pb-0 last:mb-0">
              <div className="flex flex-col items-center flex-shrink-0">
                <span className={`px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap ${typeColors[update.type] || 'bg-background-200 text-foreground-500'}`}>
                  {update.type}
                </span>
                {i < updates.length - 1 && (
                  <div className="w-px flex-1 bg-background-200 mt-2"></div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-800 mb-1">{update.title}</h3>
                <p className="text-xs text-foreground-500 mb-1">{update.desc}</p>
                <span className="text-xs text-foreground-400">{update.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}